import React from 'react';
import { Link } from 'react-router';

import Navbar from 'react-bootstrap/lib/Navbar';
import NavItem from 'react-bootstrap/lib/NavItem';
import { default as BaseNav } from 'react-bootstrap/lib/Nav';
import { LinkContainer } from 'react-router-bootstrap';

import { LangSwitch } from '../../Localizer';
import { Translate } from 'react-redux-i18n';

import './NewStyle.scss';

export const Title = ({ children, hide }) => (
  <h2 className="title">
    {!hide && <div className="quote" />}
    {children}
  </h2>
);

export const Text = ({ children, className }) => (
  <div className={`text ${className ? className : ''}`}>{children}</div>
);
export const Subtitle = ({ children }) => (
  <h3 className="sub-title">{children}</h3>
);
export const Nav = ({ hideAvatar, suffix }) => (
  <Navbar collapseOnSelect className="progkids-nav navbar-default">
    <Navbar.Header>
      <Navbar.Brand>
        <Link to="/" className="brand">
          <img
            src={require(`../../../assets/images/landings/logo${
              suffix ? suffix : ''
            }.png`)}
            className="brand-logo"
            alt="progkids"
          />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle className="pull-left" />
    </Navbar.Header>
    <Navbar.Collapse>
      <BaseNav pullRight>
        <LinkContainer to="/blog">
          <NavItem>
            <Translate value="landings.nav.blog" />
          </NavItem>
        </LinkContainer>

        <LinkContainer to="/plan">
          <NavItem>
            <Translate value="landings.nav.tariffs" />
          </NavItem>
        </LinkContainer>

        <LinkContainer to="/i/auth">
          <NavItem>
            <span className="with-border">
              <Translate value="landings.nav.account" /> &nbsp;
              {!hideAvatar ? (
                <img
                  className="avatar"
                  src={require('../../../assets/images/avatars/default.jpg')}
                  alt="avatar default"
                />
              ) : (
                <i className="fa fa-user-o" aria-hidden="true" />
              )}
            </span>
          </NavItem>
        </LinkContainer>

        <LangSwitch />
      </BaseNav>
    </Navbar.Collapse>
  </Navbar>
);
